module.exports = "/_next/static/images/fallback_logo-95691133195a8a454136b41c66e0e74c.png";